export enum ADJUSTABLE_FIELDS {
    TERM = 'Term',
    APR = 'APR',
    MONEY_FACTOR = 'Money Factor',
    DOWN_PAYMENT = 'Down Payment',
    SELLING_PRICE = 'Selling Price',
    BALLOON_AMOUNT = 'Balloon Amount'
}

export const enum ActivityText {
    Show = 'Show All',
    Hide = 'Hide All',
    Masking = '*******'
}
